var map = {
	"./audio-placeholder": 719,
	"./audio-placeholder.png": 719,
	"./avatar-missing": 378,
	"./avatar-missing.png": 378,
	"./avatar-missing.svg": 898,
	"./header-missing": 381,
	"./header-missing.png": 381,
	"./soapbox-logo": 382,
	"./soapbox-logo-white": 383,
	"./soapbox-logo-white.svg": 383,
	"./soapbox-logo.svg": 382,
	"./video-placeholder": 720,
	"./video-placeholder.png": 720,
	"./void": 721,
	"./void.png": 721,
	"./web-push/web-push-icon_expand": 842,
	"./web-push/web-push-icon_expand.png": 842,
	"./web-push/web-push-icon_favourite": 843,
	"./web-push/web-push-icon_favourite.png": 843,
	"./web-push/web-push-icon_reblog": 844,
	"./web-push/web-push-icon_reblog.png": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 897;